export default "__VITE_ASSET___tWJDKpQ__"